var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmeBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4375 2.13281L26.1301 5.32031L29.75 5.76019L27.0938 8.154L27.625 11.6953L24.4375 9.70312L21.25 11.6953L21.7812 8.154L19.125 5.76019L22.8438 5.32031L24.4375 2.13281Z",
    fill: "#1976D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1367 14.0918L22.0776 13.5627C21.7085 14.9846 20.9263 16.2651 19.8297 17.2426C18.7331 18.2201 17.3714 18.8507 15.9167 19.0547C14.4619 19.2586 12.9793 19.0269 11.6562 18.3886C10.3331 17.7503 9.22882 16.7343 8.48293 15.4687C7.73704 14.2032 7.38298 12.7449 7.46547 11.2782C7.54796 9.81155 8.06331 8.40221 8.94641 7.22828C9.82951 6.05435 11.0407 5.1685 12.4271 4.68263C13.8134 4.19676 15.3126 4.13269 16.7354 4.49849L17.2655 2.44043C15.1915 1.90095 12.9963 2.07459 11.0329 2.93344C9.06952 3.79229 7.45196 5.28645 6.44033 7.17568C5.4287 9.06492 5.08177 11.2395 5.45533 13.3497C5.82888 15.4599 6.90121 17.3832 8.49991 18.8104V31.8897L14.8749 27.6397L21.2499 31.8897V18.8295C22.6612 17.5719 23.6662 15.9226 24.1367 14.0918ZM19.1249 27.9192L14.8749 25.0855L10.6249 27.9192V20.2554C11.9434 20.9181 13.3985 21.2638 14.8742 21.2649C16.3499 21.266 17.8054 20.9225 19.1249 20.2617V27.9192Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmeBadge);
export default __webpack_public_path__ + "static/media/sme-badge.f3badeedca9b598b346d8ab2aeca7df4.svg";
export { ForwardRef as ReactComponent };